import { Container } from '@mui/material';
import { NextPage } from 'next';
import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import Page, { BooksPageProps } from './Page';
import HeaderBar from '@components/HeaderBar';
import { MARGIN_BEFORE_FOOTER } from '@styles/consts';

const Books: NextPage<BooksPageProps> = ({ books }) => {
    const { t } = useTranslation('books');

    return (
        <>
            <Head>
                <title>{t('meta.title')}</title>
                <meta content={t('meta.description')} name="description" />
            </Head>
            <HeaderBar subtitle={t('subtitle')} title={t('mainTitle')} />
            <Container maxWidth="lg" sx={{ mb: MARGIN_BEFORE_FOOTER }}>
                <Page books={books} />
            </Container>
        </>
    );
};

export default Books;
